import { ageOn, dateToFormValue, parseFormDate } from '@usacsmideo/types';

export const DOB_INVALID_MESSAGE = 'Date of Birth is invalid';
export const DOB_UNDER_18_MESSAGE = '*Patient must be at least 18 years old to receive services';

/**
 * The 18+ check on a DOB form value (CU-17tm466qvta). The value is a 'yyyy-MM-dd' calendar date, so the age is
 * counted from that date to the patient's LOCAL today with `ageOn`.
 *
 * ⚠️ NEVER `differenceInYears(Date.now(), new Date(value))`: `new Date('yyyy-MM-dd')` IS UTC MIDNIGHT, THE EVENING
 * BEFORE IN US TIME, SO THE GATE OPENED A DAY BEFORE THE 18TH BIRTHDAY.
 *
 * A legacy stored string (an ISO date-time or 'M/D/YYYY') reaches the form unchanged through `formatDateForCalendar`,
 * so the value goes through `dateToFormValue` first. Anything it can't read is invalid.
 */
export function validateAdultDob(value: string, now: Date = new Date()): string | undefined {
  const formValue = dateToFormValue(value);
  const birth = formValue ? parseFormDate(formValue) : undefined;
  if (!birth) {
    return DOB_INVALID_MESSAGE;
  }
  return ageOn(birth, now) < 18 ? DOB_UNDER_18_MESSAGE : undefined;
}
